/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';

@Injectable({
  providedIn: 'root'
})
export class DeliveryEmployeeSelectableResourceService extends SelectableResourceService<DelEmployeeVoModel>{

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('deliveryEmployeeUrl')}`,
      DelEmployeeVoModel
    )
  }
}
